import React from 'react';
import { Menu, MenuItem, ListItemIcon, ListItemText, useTheme } from '@mui/material';
import { NavLink, useLocation } from 'react-router-dom';
import { addMenuList } from './addMenuItems';

export const AddMenu = ({ anchorEl, onClose }) => {
	const location = useLocation();
	const theme = useTheme();

	return (
		<Menu
			id='add-menu-appbar'
			anchorEl={anchorEl}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
			keepMounted
			transformOrigin={{ vertical: 'top', horizontal: 'right' }}
			open={Boolean(anchorEl)}
			onClose={onClose}
			sx={{
				'& .MuiTypography-root': {
					fontSize: '13px',
					color: theme.palette.text.primary,
				},
				'& .MuiListItemIcon-root': {
					minWidth: '2.25em',
				},
			}}
		>
			{addMenuList.map((item, index) => (
				<MenuItem
					key={`${index}-${item.text}`}
					{...(!location.pathname.includes(item.link)
						? {
								component: NavLink,
								to: item.link,
							}
						: { disabled: true })}
				>
					<ListItemIcon>
						<item.Icon
							width='25px'
							height='25px'
							bgColor='transparent'
							color={theme.palette.primary.main}
						/>
					</ListItemIcon>
					<ListItemText primary={item.text} />
				</MenuItem>
			))}
		</Menu>
	);
};
